import http from "./http";

const apiEndpoint = process.env.REACT_APP_BASE_URL + "/api/ErrandVacation";

export function getErrVacList(type, addId) {
  return http.post(`${apiEndpoint}/GetDropDown/?type=${type}&addId=${addId}`);
}
